<h1 mat-dialog-title>Send Confirmation</h1>
<div mat-dialog-content>
  <div class="flex-col">
    <div>
      <p class="mat-body-1" *ngIf="data.messagePreferenceId == 1">Appointment Confirmation will be sent via
        Email to <i>{{data.emailAddress}}</i></p>
      <p class="mat-body-1" *ngIf="data.messagePreferenceId == 2">Appointment Confirmation will be sent via
        Text to <i>{{data.phoneNumber}}</i></p>
    </div>
  </div>
</div>
<div mat-dialog-actions class="justify-end">
  <button mat-button mat-dialog-close="cancelled">Cancel</button>
  <button mat-button mat-dialog-close="confirmed" color="primary" cdkFocusInitial>Send</button>
</div>
